export default "__VITE_ASSET__DVfLdNa2__"